(() => {
  if (window.bpCategoryMenu) { window.bpCategoryMenu.init(document); return; }
  const mounted = new Map();
  const desktop = matchMedia('(min-width: 751px)');
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  const init = scope => {
    scope.querySelectorAll('[data-bp-category-navigation]').forEach(nav => {
      if (mounted.has(nav)) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const menuButton = nav.querySelector('.bp-category-menu-toggle');
      const items = [...nav.querySelectorAll('[data-bp-submenu]')];
      let suppressFocus = false;
      let timer;
      const setOpen = (item, open) => {
        item.classList.toggle('is-open', open);
        item.querySelector('.bp-submenu-toggle').setAttribute('aria-expanded', String(open));
      };
      const closeAll = () => { clearTimeout(timer); items.forEach(item => setOpen(item, false)); };
      menuButton.addEventListener('click', () => {
        const open = !nav.classList.contains('is-menu-open');
        nav.classList.toggle('is-menu-open', open);
        menuButton.setAttribute('aria-expanded', String(open));
        if (!open) closeAll();
      }, options);
      items.forEach(item => {
        const button = item.querySelector('.bp-submenu-toggle');
        item.addEventListener('pointerenter', () => {
          clearTimeout(timer);
          if (desktop.matches && hover.matches) { closeAll(); setOpen(item, true); }
        }, options);
        item.addEventListener('pointerleave', () => {
          if (desktop.matches && hover.matches && !item.contains(document.activeElement)) {
            timer = setTimeout(() => setOpen(item, false), 100);
          }
        }, options);
        item.addEventListener('focusin', event => {
          if (!suppressFocus && desktop.matches && event.target !== button) { closeAll(); setOpen(item, true); }
        }, options);
        item.addEventListener('focusout', event => {
          if (!item.contains(event.relatedTarget)) setOpen(item, false);
        }, options);
        button.addEventListener('click', () => {
          const open = !item.classList.contains('is-open');
          closeAll(); setOpen(item, open);
        }, options);
      });
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || event.defaultPrevented) return;
        const activeItem = items.find(item => item.classList.contains('is-open'));
        if (activeItem) {
          event.preventDefault(); closeAll(); suppressFocus = true;
          activeItem.querySelector('.bp-submenu-toggle').focus(); suppressFocus = false;
        } else if (!desktop.matches && nav.classList.contains('is-menu-open')) {
          nav.classList.remove('is-menu-open'); menuButton.setAttribute('aria-expanded', 'false'); menuButton.focus();
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!nav.contains(event.target)) closeAll();
      }, options);
      desktop.addEventListener('change', () => {
        closeAll(); nav.classList.remove('is-menu-open'); menuButton.setAttribute('aria-expanded', 'false');
      }, options);
      nav.setAttribute('data-bp-menu-ready', 'true');
      mounted.set(nav, () => { clearTimeout(timer); controller.abort(); });
    });
    scope.querySelectorAll('[data-bp-hover-details]').forEach(details => {
      if (mounted.has(details)) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let wasOpen;
      details.addEventListener('mouseover', event => {
        if (!hover.matches || details.contains(event.relatedTarget) || wasOpen !== undefined) return;
        wasOpen = details.open; details.open = true;
      }, options);
      details.addEventListener('mouseout', event => {
        if (!hover.matches || details.contains(event.relatedTarget) || wasOpen === undefined || details.contains(document.activeElement)) return;
        details.open = wasOpen; wasOpen = undefined;
      }, options);
      mounted.set(details, () => controller.abort());
    });
  };
  window.bpCategoryMenu = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [element, cleanup] of mounted) if (event.target.contains(element)) { cleanup(); mounted.delete(element); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
